<template>
	<div>
		<van-nav-bar :title="$t('Membership card')" class="custom-nav" :border="false">
			<template #left>
				<van-icon name="arrow-left" color="#e6b98a" size="24" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="membership-card-page">
			<div class="card-container">
				<div class="membership-card unauth">
					<img src="/img/mine/1bb3e606-5551-4bb4-bb30-c14be9e5d5ab.jpg" class="card-bg">
					<div class="card-content">
						<div class="card-info">
							<div class="info-row">
								<!--<span class="label">{{$t('Cardholder')}}</span>-->
								<span class="value">{{userInfo.username}}</span>
							</div>
							<div class="info-row">
								<!--<span class="label">{{$t('Card number')}}</span>-->
								<span class="value">0000{{userInfo.uid}}</span>
							</div>
							<div class="info-row">
								<!--<span class="label">{{$t('Validity period')}}</span>-->
								<span class="value">-</span>
							</div>
						</div>
						<!--
						<div class="auth-status">
							<div class="lock-icon">
								<img src="img/mine/m3.png" class="lock-img">
							</div>
							<div class="status-text">{{$t('Unauth')}}</div>
						</div>
						-->
					</div>
				</div>
				<button @click="tishi"
					class="download-btn van-button van-button--primary van-button--normal van-button--block">
					{{$t('Download Vip Card')}}
				</button>


			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				money: "",
				paypassword: "",
				showPopover: false,
				withdraw_money: "",
				userInfo: {},
				withdrawRole: {},
				bankInfo: {},
				currentLevel: null
			};
		},
		methods: {
			// 获取当前用户等级信息
			getCurrentLevel() {
				if (!this.userInfo.all_levels || !this.userInfo.vip) return null;
				return this.userInfo.all_levels.find(level => level.name === this.userInfo.vip);
			},

			// 获取当前等级最大提现金额
			getCurrentLevelWithdrawMax() {
				const level = this.getCurrentLevel();
				return level ? level.withdraw_max_amount : this.withdrawRole.max;
			},

			// 获取当前等级最小提现金额
			getCurrentLevelWithdrawMin() {
				const level = this.getCurrentLevel();
				return level ? level.withdraw_min_amount : this.withdrawRole.min;
			},

			// 获取当前等级最小完成单数
			getCurrentLevelMinCompletedOrders() {
				const level = this.getCurrentLevel();
				return level ? level.min_completed_orders : 0;
			},

			// 获取当前等级提现手续费
			getCurrentLevelWithdrawFee() {
				const level = this.getCurrentLevel();
				return level ? level.withdraw_fee : '0';
			},

			// 获取当前等级提现次数
			getCurrentLevelWithdrawCount() {
				const level = this.getCurrentLevel();
				return level ? level.withdraw_count : 0;
			},

			getUserBankInfo() {
				this.$http({
					method: 'get',
					url: 'user_get_bank'
				}).then(res => {

					if (res.code === 200) {
						this.bankInfo = res.data.info || {};
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			back() {
				return window.history.back();
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
						this.name = res.data.name;
						console.log('用户信息:', this.userInfo);
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			getUserWithdrawRole() {
				this.$http({
					method: 'get',
					url: 'user_get_withdraw_role'
				}).then(res => {
					if (res.code === 200) {
						console.log(res.data, "res.data---119")
						this.withdrawRole = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			allMoeny() {
				this.withdraw_money = this.userInfo.money;
			},
			tishi() {
				this.$toast(this.$t("Please activate membership first"));
			},
			doWithdraw() {
				if (!this.paypassword) {
					this.$toast(this.$t('q24'));
					return false;
				}

				if (!this.withdraw_money || this.withdraw_money <= 0) {
					this.$toast(this.$t("setting.correct_money"));
					return false;
				}

				// 验证提现条件
				const amount = parseFloat(this.withdraw_money);
				const minAmount = parseFloat(this.getCurrentLevelWithdrawMin());
				const maxAmount = parseFloat(this.getCurrentLevelWithdrawMax());
				const balance = parseFloat(this.userInfo.money);
				const todayCompleted = this.userInfo.daily_order_limit ? this.userInfo.daily_order_limit.today_completed :
					0;
				const minCompletedOrders = this.getCurrentLevelMinCompletedOrders();

				if (amount < minAmount) {
					this.$toast(`${this.$t('withdraw.min_amount_error')} ${minAmount}`);
					return false;
				}

				if (amount > maxAmount) {
					this.$toast(`${this.$t('withdraw.max_amount_error')} ${maxAmount}`);
					return false;
				}

				if (amount > balance) {
					this.$toast(this.$t('withdraw.insufficient_balance'));
					return false;
				}

				if (todayCompleted < minCompletedOrders) {
					this.$toast(`${this.$t('withdraw.min_orders_error')} ${minCompletedOrders}`);
					return false;
				}

				this.$http({
					method: 'post',
					data: {
						money: this.withdraw_money,
						paypassword: this.paypassword
					},
					url: 'user_set_withdraw'
				}).then(res => {
					if (res.code === 200) {
						this.$toast(res.msg);
						this.getUserInfo();
						this.getUserWithdrawRole();
						this.withdraw_money = '';
						this.paypassword = '';
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			withdrawInfo() {
				this.showPopover = true;
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserInfo();
				this.getUserWithdrawRole();
			}
		},
		mounted() {
			this.getUserBankInfo();
		}
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.withdraw-page {
		background-color: #1f1c1f;
		min-height: 100vh;
		display: flex;
		flex-direction: column;
	}

	/* 导航栏暗金风格 */
	.custom-nav {
		background-color: #1f1c1f !important;
		position: relative;
		z-index: 10;
	}

	::v-deep .custom-nav .van-nav-bar__title {
		color: #e6b98a !important;
		font-size: 36px;
	}

	::v-deep .van-hairline--bottom::after {
		border-bottom-width: 0 !important;
	}

	/* Balance Banner */
	.balance-banner {
		background: linear-gradient(to right, #e2bb91, #d4a572);
		height: 240px;
		padding: 40px 60px 0;
		box-sizing: border-box;
	}

	.balance-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #000;

		.balance-val {
			font-size: 40px;
			font-weight: bold;
		}

		.balance-label {
			font-size: 36px;
			font-weight: bold;
		}
	}

	/* Main Content */
	.main-content {
		flex: 1;
	}

	.form-card {
		background-color: #212025;
		border-radius: 40px 40px 0 0;
		margin-top: -60px;
		padding: 60px 40px 40px;
		position: relative;
		z-index: 5;
		min-height: 500px;
	}

	.membership-card-page .membership-card .card-content .auth-status {
		position: absolute;
		left: 5.333vw;
		bottom: 5.333vw;
		text-align: center;
	}

	.membership-card-page .membership-card .card-content .auth-status .lock-icon {
		width: 10.667vw;
		height: 10.667vw;
		border: .267vw solid #7a9ec0;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 1.333vw;
	}

	.membership-card-page .membership-card .card-content .auth-status .lock-icon .lock-img {
		width: 5.333vw;
		height: 5.333vw;
		opacity: .6;
	}

	.membership-card-page .membership-card .card-content .auth-status .status-text {
		font-size: 2.933vw;
		color: #7a9ec0;
	}

	.membership-card-page .download-btn {
		background: linear-gradient(90deg, #eec9a4, #ddac77);
		border: none;
		height: 12vw;
		font-size: 4.267vw;
		border-radius: 1.333vw;
		color: #fff;
	}

	/* 账户信息 */
	.user-info-row {
		display: flex;
		align-items: center;
		margin-bottom: 30px;
		color: #e6b98a;
		font-size: 32px;
		background: #2b2b2b;
		padding: 24px;
		border-radius: 16px;
		border: 1px solid #3a3a3a;

		.icon {
			font-size: 40px;
			margin-right: 16px;
		}

		.label {
			margin-right: 16px;
			color: #999;
		}

		.value {
			font-weight: bold;
			color: #fff;
		}
	}

	/* 银行卡选择 */
	.bank-row {
		display: flex;
		align-items: center;
		background: linear-gradient(135deg, #4a3c31, #2b2b2b);
		border: 2px solid #766350;
		border-radius: 16px;
		padding: 30px 24px;
		margin-bottom: 40px;

		.bank-icon {
			font-size: 48px;
			color: #e6b98a;
			margin-right: 20px;
		}

		.bank-detail {
			flex: 1;
			display: flex;
			flex-direction: column;

			.bank-name {
				color: #fff;
				font-size: 32px;
				font-weight: bold;
				margin-bottom: 8px;
			}

			.bank-num {
				color: #999;
				font-size: 28px;
				font-family: monospace;
			}
		}

		.check-icon {
			font-size: 40px;
			color: #07c160;
		}
	}

	/* Input Area */
	.input-area {
		display: flex;
		align-items: center;
		border-bottom: 2px solid #333;
		padding-bottom: 20px;
		margin-bottom: 40px;

		.currency-symbol {
			color: #df9452;
			font-size: 48px;
			margin-right: 20px;
			font-weight: 500;

			&.icon-lock {
				font-size: 40px;
			}
		}

		.money-input {
			flex: 1;
			background: transparent;
			border: none;
			color: #fff;
			font-size: 40px;
			outline: none;

			&::placeholder {
				color: #555;
				font-size: 32px;
			}
		}
	}

	/* Confirm Button */
	.confirm-btn {
		width: 100%;
		height: 100px;
		background: linear-gradient(to bottom, #a08873, #725842);
		border: none;
		border-radius: 12px;
		color: #4a2c1d;
		font-size: 36px;
		font-weight: bold;
		cursor: pointer;
		margin-top: 20px;
		margin-bottom: 40px;
		transition: all 0.2s;

		&:active {
			opacity: 0.9;
			transform: translateY(2px);
		}
	}

	.membership-card-page .card-container {
		padding: 5.333vw;
	}

	.membership-card-page {
		min-height: 100vh;
		background-color: #101012;
		/*padding-top: 13.333vw;*/
	}

	.membership-card-page .membership-card {
		position: relative;
		width: 100%;
		border-radius: 2.667vw;
		overflow: hidden;
		margin-bottom: 5.333vw;
	}

	.membership-card-page .membership-card.unauth .card-bg {
		filter: grayscale(30%);
	}

	.membership-card-page .membership-card .card-bg {
		width: 100%;
		display: block;
	}

	.membership-card-page .membership-card .card-content {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-right: 5.333vw;
	}

	.membership-card-page .membership-card .card-content .card-info {
		text-align: left;
	}

	.membership-card-page .membership-card .card-content .card-info .info-row {
		margin-bottom: 4vw;
	}

	.membership-card-page .membership-card .card-content .card-info .info-row .label {
		display: block;
		font-size: 3.2vw;
		color: #333;
		margin-bottom: 1.067vw;
		font-weight: 700;
	}

	.membership-card-page .membership-card .card-content .card-info .info-row .value {
		display: block;
		font-size: 3.733vw;
		color: #666;
		background: hsla(0, 0%, 100%, .6);
		padding: 1.067vw 2.667vw;
		border-radius: .8vw;
		min-width: 26.667vw;
	}

	/* 说明 */
	.shuoming {
		background: #242424;
		color: #999;
		padding: 40px;
		border-radius: 20px;
		margin: 0 40px 40px;
		border: 1px solid #333;

		.l_p {
			font-size: 26px;
			margin-top: 20px;
			line-height: 1.5;

			&.q1 {
				font-size: 30px;
				color: #e6b98a;
				margin-top: 0;
				margin-bottom: 30px;
				font-weight: bold;
				display: flex;
				align-items: center;

				.van-icon {
					margin-right: 10px;
					font-size: 36px;
				}
			}
		}
	}
</style>